export const openTab = (link, e) => {
  e && e.preventDefault();
  e && e.stopPropagation();

  if (window && typeof window === 'object') {
    // we are client-side
    window.open(link);
  }
};
